export default __webpack_public_path__ + "static/media/Resultadofinal0002.bd24d666.pdf";